import * as yup from "yup";

export const getSchema = (
  includeOwnershipPercentage: boolean,
  requireAmlEntityType: boolean = false,
) =>
  yup.object().shape({
    ...(includeOwnershipPercentage
      ? {
          ownershipPercentage: yup.number().when("isOwner", {
            is: true,
            then: (schema) =>
              schema
                .required("Ownership percentage is required if owner is selected")
                .typeError("Ownership percentage must be a number")
                .positive("Ownership percentage must be positive"),
          }),
        }
      : {}),
    ...{
      // Entity-only fields
      entityType: yup.string().required("Entity type required"),
      amlEntityType: requireAmlEntityType
        ? yup.string().required("AML entity type required")
        : yup.string(),
      entityName: yup.string().required("Entity name required"),
      taxId: yup.string().min(5, "Tax Id must be at least 5 characters"),
      // Address fields
      streetLine1: yup.string(),
      streetLine2: yup.string(),
      city: yup.string(),
      stateOrProvince: yup.string(),
      country: yup.string().required("Country required"),
      zipCode: yup.string(),
      natureOfBusiness: yup.string(),
      principalPlaceOfBusiness: yup.string(),
      registrationNumber: yup.string(),
      isOwner: yup.boolean(),
      isController: includeOwnershipPercentage
        ? yup
            .boolean()
            .test("at-least-one-role", "At least one role must be selected", function (value) {
              const { isOwner } = this.parent as { isOwner: boolean };
              return isOwner === true || value === true;
            })
        : yup.boolean(),
    },
  });
